<svelte:head>
    <!-- cloud project - Estateweb App -->
<!--    <script src="https://maps.googleapis.com/maps/api/js?key=AIzaSyACGm9y-lSp66PODj0-uxkUCAa09RR9TPI&libraries=places&callback=initMap"-->
<!--            async defer></script>-->
    <script src="https://maps.googleapis.com/maps/api/js?key=AIzaSyC9fLyiHvwlN-lt92FcgdUxYgsGVl9H3u0&libraries=places&callback=initMap"
            async defer></script>
</svelte:head>

<script>
    import {onMount} from 'svelte';
    import app from "./stores/app";
    import appAlert from "./stores/appAlert";
    import R from "./lib/requests";
    import {lang} from './lib/lang';
    import {scrollToElement} from './lib/lib';
    import MainEnglish from "./MainEnglish.svelte";
    import Loader from "./components/Loader.svelte";
    import Alert from "./components/Alert.svelte";
    import MainGreek from "./MainGreek.svelte";

    let oldStep = 1;
    let loading = false;
    let initialized = false;


    window.initMap = function ready() {
        $app.mapInitialized = true;
    }

    const initializeLanguage = () => {
        // get the language
        let languages = ['el', 'en'];
        $app.language = window.document.documentElement.lang;
        if (languages.indexOf($app.language) < 0) {
            $app.language = 'en';
        }

        $app.lang = lang[$app.language];

        // get the partner!
        let main = document.getElementById("main");
        $app.partner = main.getAttribute('data-from');
        // console.log("PARTNER", $app.partner);
    }

    const initializeApp = () => {

        const onSuccess = result => {
            $app.settings = result;

            app.initializeTickets();

            loading = false;
            initialized = true;
        };

        const onFailure = err => {
            appAlert.error("Error connecting to server...\nPlease refresh this page.");
            loading = false;
        };

        loading = true;

        R.handle(R.tickets.init, [], onSuccess, onFailure);
    };

    onMount(() => {
        let main = document.getElementById('main');
        if (main) {
            let fragment = document.createDocumentFragment();
            fragment.appendChild(document.getElementById('cart'));
            main.appendChild(fragment);
        }

        initializeLanguage();
        initializeApp();
    });

    window.addEventListener('resize', function (event) {
        app.windowResize();
    });
    app.windowResize();

    $:{
        if (oldStep != $app.cartStep) {
            oldStep = $app.cartStep;
            if ($app.cartStep > 0) {
                scrollToElement("main");
            }
        }
    }
</script>

<div id="cart">
    {#if initialized}
        {#if $app.language === 'en'}
            <MainEnglish/>
        {:else}
            <MainGreek/>
        {/if}
    {/if}
</div>
<Alert/>

<Loader {loading}/>